import { useSelector } from "react-redux"
import { get } from "lodash-es"
const useSelectionActive = () => {
  return useSelector(state => {
    const demands = get(state, "selector.demands.selected")
    return demands && Object.keys(demands).length > 0
  })
}

export default useSelectionActive
